import type { Translations } from './pt-BR';

const es: Translations = {
  nav: {
    dashboard:    'Inicio',
    forecast:     'Predicción',
    birthChart:   'Carta Natal',
    synastry:     'Sinastría',
    questions:    'Pregunta a los Astros',
    astromatch:   'AstroMatch',
    tarot:        'Tarot de Marsella',
    lenormand:    'Barajas Gitanas',
    numerology:   'Numerología',
    iChing:       'I Ching',
    dreamJournal: 'Diario de Sueños',
    moonPhases:   'Fases de la Luna',
    agenda:       'Agenda Astrológica',
    retrograde:   'Radar Retrógrado',
    eclipses:     'Eclipse Insight',
    astroPet:     'Astro Pet',
    astroCoach:   'Astro Coach',
    startAstral:  'Rota Profissional',
    empresas:     'Empresas',
    astrocartografia:    'Astrocartografia',
    wallet:         'Cartera',
    readings:       'Lecturas',
    settings:       'Configuración',
    signOut:        'Cerrar sesión',
    quiromancy:     'Quiromancia',
    vedicAstrology: 'Astrología Védica',
    humanDesign:    'Diseño Humano',
    blog:           'Blog',
    pricing:        'Planes',
  },
  credits: {
    questions:  'Créditos de preguntas',
    synastry:   'Créditos de sinastría',
    astromatch: 'Créditos AstroMatch',
  },
  home: {
    heroBadge:       'Personalizado para ti. No para tu signo.',
    heroHeadline1:   'Secreto',
    heroHeadline2:   'Astral.',
    heroSubheadline: 'Astrología, tarot, I Ching, numerología y más, revelados específicamente para ti.',
    heroCta1:        'Descubre tu Secreto Astral →',
    heroCta2:        'Ver predicciones de hoy',
    heroSocialProof: '✦ Más de 50.000 lecturas realizadas',
    heroScrollHint:  'Ver predicciones por signo',

    signForecastTitle:    'Predicción del día',
    signForecastSubtitle: 'Selecciona tu signo y consulta lo que los astros tienen para ti hoy.',
    forecastToday:        'Predicción de hoy',
    forecastWeek:         'Predicción de esta semana',
    forecastMonth:        'Predicción de este mes',
    consultingStars:      'Consultando los astros para {sign}...',
    starsMoving:          'Los astros están en movimiento. Intenta de nuevo en un momento ✦',
    seeFullForecast:      'Ver predicción completa ✦',

    featureTitle:    'Todo lo que necesitas, en un solo lugar',
    featureSubtitle: 'Desde predicciones diarias hasta la carta natal completa, 3.000 años de tradición al alcance de tu día.',
    startFree:       'Comenzar gratis ✦',

    feat: {
      birthChartTitle:    'Carta Natal',
      birthChartDesc:     'Descubre tus planetas, casas y aspectos con interpretación completa en español.',
      birthChartBadge:    'Premium',
      forecastTitle:      'Predicción Personalizada',
      forecastDesc:       'Predicciones diarias, semanales y mensuales calculadas para tu carta natal.',
      synastryTitle:      'Sinastría',
      synastryDesc:       'Compara tu carta con la de alguien especial y ve la compatibilidad completa.',
      synastryBadge:      'Premium',
      questionsTitle:     'Pregunta a los Astros',
      questionsDesc:      'Haz cualquier pregunta y recibe una respuesta astrológica personalizada.',
      astromatchTitle:    'AstroMatch',
      astromatchDesc:     'Sube una foto y descubre la personalidad astrológica a través de la fisiognomía.',
      astromatchBadge:    'Exclusivo',
      moreTitle:          'Tarot, I Ching y más',
      moreDesc:           'Tirada de Tarot, I Ching, Numerología, Diario de Sueños y Fases de la Luna.',
    },

    premiumBadge:   '✦ Plan Premium',
    premiumTitle1:  'Sumérgete',
    premiumTitle2:  'en tus astros',
    premiumDesc:    'Con Professya Premium tienes acceso a la carta natal completa, sinastría ilimitada, predicciones personalizadas y mucho más, por menos de $1 al día.',
    premiumF1:      'Carta natal completa con interpretación',
    premiumF2:      'Predicciones diarias, semanales y mensuales',
    premiumF3:      'Sinastría de relaciones',
    premiumF4:      'Preguntas ilimitadas a los astros',
    premiumF5:      'AstroMatch por foto',
    premiumF6:      'Acceso a Tarot, I Ching y Numerología',
    premiumPrice:   '$4,99',
    premiumPer:     '/mes',
    premiumCta:     'Suscribirse ahora ✦',
    premiumCancel:  'Cancela cuando quieras. Sin compromiso.',

    demoLabel1: 'Carta Natal',
    demoSub1:   'Sol en Aries · Luna en Tauro · ASC Géminis',
    demoLabel2: 'Sinastría',
    demoSub2:   'Compatibilidad 87% ✦ Venus en armonía',
    demoLabel3: 'Predicción de hoy',
    demoSub3:   '"Venus favorece conexiones profundas..."',

    servicesTitle:    'Nuestros Servicios',
    servicesSubtitle: 'Desde predicciones diarias hasta cartas natales completas, todo para tu autoconocimiento astrológico.',
    servicesCta:      'Acceder a todos los servicios ✦',
    badgePlan:        'Plan',
    badgeCredits:     'Créditos',
    badgeAvulso:      'Unitario',
    badgeNew:         'Nuevo ✦',
    svc: {
      birthChart:  { name: 'Carta Natal',              subtitle: 'Tu carta natal completa',                    description: 'Descubre la posición exacta de todos los planetas, casas y aspectos en el momento de tu nacimiento. No es un horóscopo genérico, es el mapa único que solo tú posees.' },
      forecast:    { name: 'Predicción Personalizada', subtitle: 'Diaria, semanal, mensual y anual',            description: 'Predicciones calculadas para TU carta natal, no para tu signo. Sabe exactamente qué planetas están activando tu vida ahora y qué esperar en los próximos meses.' },
      synastry:    { name: 'Sinastría',                subtitle: 'Compatibilidad profunda entre dos cartas',   description: 'Analiza la conexión real entre dos cartas natales. Descubre los aspectos que crean atracción, tensión, misión kármica y potencial a largo plazo en cualquier relación.' },
      astroMatch:  { name: 'AstroMatch',               subtitle: 'Compatibilidad antes del primer encuentro', description: 'Indica el nombre, signo y algunas características de alguien y descubre el potencial astrológico de esa conexión antes de involucrarte. Ahorra tiempo y energía.' },
      astrocartografia: { name: 'Astrocartografia',             subtitle: 'Dónde en el mundo prosperas',               description: 'Compara tu carta natal con la de 195 países y descubre dónde tienes más potencial de amor, carrera, salud y calidad de vida. También analiza cualquier ciudad específica.' },
      questions:   { name: 'Pregunta a los Astros',    subtitle: 'Respuestas directas del oráculo',           description: 'Haz cualquier pregunta y recibe una respuesta personalizada basada en los tránsitos planetarios activos en tu carta natal en este momento.' },
      tarot:       { name: 'Tarot de Marsella',         subtitle: '4 tipos de tirada interpretados',           description: 'Tiradas de 1, 3, 7 y 10 cartas con interpretación profunda basada en la tradición del Tarot de Marsella, combinada con la posición de tus planetas en el momento de la consulta.' },
      lenormand:   { name: 'Barajas Gitanas',           subtitle: 'El oráculo Lenormand de 36 cartas',          description: 'Las Barajas Gitanas revelan patrones ocultos de tu vida a través de las 36 cartas de Lenormand. Elige tiradas de 1, 3, 5 o 9 cartas con interpretación personalizada.' },
      numerology:  { name: 'Numerología',              subtitle: 'Los números que rigen tu vida',             description: 'Número del Destino, Alma, Personalidad y Año Personal calculados a partir de tu nombre completo y fecha de nacimiento. Descubre los ciclos que gobiernan tu viaje.' },
      astroPet:    { name: 'Astro Pet',                subtitle: 'La carta natal de tu animal',               description: 'Calcula la carta natal de tu mascota y descubre su personalidad astrológica. Analiza también la compatibilidad entre tú y tu animal de compañía.' },
      startAstral: { name: 'Rota Profissional',             subtitle: 'Tu vocación por la carta natal',            description: 'Análisis completo de tu Medio Cielo, Saturno, Júpiter y Nodo Norte para revelar tu vocación, talentos naturales y el camino profesional más alineado con quien eres.' },
      retrograde:  { name: 'Radar Retrógrado',         subtitle: 'Impacto real en tu carta',                  description: 'Sabe exactamente cómo Mercurio, Venus, Marte y otros planetas retrógrados afectan TU carta natal, no una predicción genérica por signo.' },
      eclipse:     { name: 'Eclipse Insight',          subtitle: 'Eclipses que activan tu vida',              description: 'Descubre qué casas y planetas de tu carta natal son activados por los eclipses solares y lunares, y qué significa eso para los próximos 6 meses de tu vida.' },
    },
  },
  auth: {
    email:            'Correo electrónico',
    password:         'Contraseña',
    confirmPassword:  'Confirmar contraseña',
    signIn:           'Iniciar sesión',
    createAccount:    'Crear cuenta',
    forgotPassword:   'Olvidé mi contraseña',
    resetPassword:    'Restablecer contraseña',
    noAccount:        '¿No tienes cuenta?',
    hasAccount:       '¿Ya tienes cuenta?',
    orContinue:       'o continúa con',
    sendReset:        'Enviar enlace de restablecimiento',
    backToLogin:      'Volver al inicio de sesión',
    checkEmail:       'Revisa tu correo para el enlace de restablecimiento.',
    signInTitle:      'Inicia sesión en tu cuenta',
    createTitle:      'Crea tu cuenta gratuita',
    name:             'Nombre',
    namePlaceholder:  'Tu nombre',
    showPassword:     'Mostrar contraseña',
    hidePassword:     'Ocultar contraseña',
    createFree:       'Crear cuenta gratis',
    createCta:        'Crear cuenta ✦',
    agreeText:        'Al crear una cuenta aceptas nuestros',
    terms:            'Términos',
    privacyPolicy:    'Política de Privacidad',
    biometricTitle:   '✦ ¿Quieres entrar más rápido?',
    biometricDesc:    'Activa Face ID / Touch ID para entrar a Professya sin escribir tu contraseña.',
    biometricEnable:  'Activar Face ID / Touch ID',
    biometricSkip:    'Ahora no',
    continueGoogle:   'Continuar con Google',
    continueApple:    'Continuar con Apple',
    oauthError:       'Error al autenticar. Inténtalo de nuevo.',
  },
  common: {
    loading:      'Cargando...',
    error:        'Error',
    retry:        'Reintentar',
    save:         'Guardar',
    cancel:       'Cancelar',
    back:         'Volver',
    close:        'Cerrar',
    confirm:      'Confirmar',
    language:     'Idioma',
  },
  dashboard: {
    cosmicBrief:       '✦ Resumen Cósmico',
    consultingStars:   'Consultando los astros para ti...',
    starsMoving:       'Los astros están en movimiento. Tu resumen cósmico estará listo en un momento ✦',
    completeBanner:    '✦ Completa tu perfil',
    completeBannerSub: 'Agrega tu fecha de nacimiento para lecturas personalizadas.',
    addData:           'Agregar datos',
    quickAccess:       'Acceso rápido',
    continueJourney:   'Continúa tu viaje',
    seeAll:            'Ver todas',
    greetingMorning:   'Buenos días',
    greetingAfternoon: 'Buenas tardes',
    greetingEvening:   'Buenas noches',
    errorTitle:        'Algo salió mal',
    errorSubtitle:     'No pudimos cargar tu perfil. Intenta actualizar la página.',
    reload:            'Actualizar',
    suggBirthChartDesc: 'Descubre tus planetas y casas astrológicas.',
    suggForecastTitle:  'Predicción de la semana',
    suggForecastDesc:   'Lo que los astros tienen reservado para ti esta semana.',
    suggQuestionsDesc:  'Haz tu primera pregunta con 1 crédito gratuito.',
    premiumBadge:        'Premium activo ✦',
    premiumWelcomeTitle: '¡Bienvenido a Professya Premium!',
    premiumWelcomeDesc:  'Explora tus primeras funciones.',
    premiumClose:        'Cerrar',
    premiumStep1:        'Carta Natal',
    premiumStep2:        'Predicción',
    premiumStep3:        'Sinastría',
    premiumStep4:        'AstroMatch',
    premiumStep5:        'Tarot',
    renewalTitle:        'Tu suscripción expira {when}',
    renewalToday:        'hoy',
    renewalTomorrow:     'mañana',
    renewalDays:         'en {days} días',
    renewalDesc:         'Renueva ahora para no perder el acceso Premium.',
    renewalCta:          'Renovar ✦',
    tierPremium:         'Premium',
    streakSingular:      'día consecutivo',
    streakPlural:        'días consecutivos',
    creditQuestionsSingular: 'pregunta',
    creditQuestionsPlural:   'preguntas',
    creditSynastry:          'sinastría',
  },
  layout: {
    navSigns:      'Signos',
    navBlog:       'Blog',
    navPlans:      'Planes',
    navMyAccount:  'Mi Cuenta',
    navSignIn:     'Iniciar sesión',
    navStartFree:  'Comenzar gratis',
    footerTagline: 'Astrología y esoterismo para tu día a día.',
    footerProduct: 'Producto',
    footerLegal:   'Legal',
    footerRights:  'Todos los derechos reservados.',
    footerMotto:   'Secreto Astral',
    footerSignos:  'Signos',
    footerBirthChart: 'Carta Natal',
    footerSynastry:   'Sinastría',
    footerQuestions:  'Preguntas',
    footerPrivacy:    'Privacidad',
    footerTerms:      'Términos de uso',
    footerLgpd:       'Política de datos',
    footerBrandTagline:  'Professya, Tu autoconocimiento revelado por los astros, tarot, I Ching y mucho más.',
    footerServices:      'Servicios',
    footerOracles:       'Oráculos',
    footerForecast:      'Predicción',
    footerAstroMatch:    'AstroMatch',
    footerAstrocartografia:   'Astrocartografia',
    footerStartAstral:   'Rota Profissional',
    footerTarot:         'Tarot',
    footerIChing:        'I Ching',
    footerNumerology:    'Numerología',
    footerAstroPet:      'Astro Pet',
    footerPrivacyFull:   'Política de Privacidad',
    footerTermsFull:     'Términos de Uso',
    footerLgpdFull:      'Política de datos',
    footerCancellation:  'Cancelación',
    footerBusiness:      'Para Empresas',
    footerContact:       'Contacto',
    footerCopyright:     '© {year} Professya. Todos los derechos reservados.',
    footerDisclaimer:    'Las lecturas tienen carácter reflexivo y de entretenimiento. ✦',
    footerNewsletterDesc: 'Novedades astrológicas en tu email. Sin spam.',
  },
  forecast: {
    title:          'Predicción',
    emptyTitle:     'Fecha de nacimiento requerida',
    emptySubtitle:  'Agrega tu fecha de nacimiento para recibir predicciones personalizadas.',
    emptyCta:       'Agregar datos',
    starsMoving:    'Los astros están en movimiento. Intenta de nuevo en un momento ✦',
    periodToday:    'Hoy',
    periodWeek:     'Esta Semana',
    periodMonth:    'Este Mes',
    periodYear:     'Este Año',
    loadingDaily:   'Consultando los astros de hoy...',
    loadingWeekly:  'Calculando la semana astrológica...',
    loadingMonthly: 'Analizando el mes en los astros...',
    loadingAnnual:  'Preparando tu predicción anual...',
    skyNow:              'Cielo Ahora',
    transitShort:        'Hoy & Esta Semana',
    transitMedium:       'Activo Hace Más de 30 Días',
    transitMediumBadge:  'Medio plazo',
    transitLong:         'Transformaciones de Fondo',
    transitLongBadge:    'Largo plazo',
    transitApproaching:  '↗ Entrando',
    transitPeak:         '◉ En el pico',
    transitSeparating:   '↘ Saliendo',
    transitLongTermChip: '⟳ Largo plazo',
    transitRetrograde:   '® Retrógrado',
    illumination:        'iluminación',
    regenerateTitle:     'Generar nueva predicción',
    regenerateCta:       '↺ Regenerar',
    stillThinking:       'Los astros aún están revelando... ✦',
  },
  tabs: {
    home:      'Inicio',
    forecast:  'Predicción',
    questions: 'Preguntar',
    match:     'Match',
    wallet:    'Cartera',
    ariaLabel: 'Navegación principal',
    map:       'Mapa',
    atlas:     'Local',
    profile:   'Perfil',
    search:    'Buscar',
    today:     'Hoy',
    me:        'Yo',
  },
  pages: {
    onboarding: {
      stepOf: 'Paso {step} de {total}',
      welcomeTitle: '¡Hola, {name}!',
      welcomeText: 'Bienvenido a Professya, tu espacio de astrología y esoterismo.\nVamos a preparar tu experiencia personalizada en pocos pasos.',
      welcomeCta: 'Comenzar ✦',
      birthDataTitle: 'Tus datos de nacimiento',
      birthDataDesc: 'Necesarios para calcular tu carta natal. La hora es opcional pero mejora la precisión.',
      birthDateLabel: 'Fecha de nacimiento',
      birthTimeLabel: 'Hora de nacimiento',
      birthCityLabel: 'Ciudad de nacimiento',
      optional: '(opcional)',
      youAreSign: '¡Eres {sign}!',
      backBtn: 'Volver',
      continueBtn: 'Continuar',
      skipNow: 'Omitir por ahora',
      skipSetup: 'Omitir configuración →',
      firstReadingTitle: 'Tu primera lectura',
      firstReadingDesc: 'Como {sign}, los astros ya tienen mucho que decirte.',
      firstReadingDesc2: 'Con tus datos completos, los astros pueden hablarte directamente.',
      previewLabel: 'Vista previa de tu panel:',
      previewFeat1Label: 'Predicción de hoy',
      previewFeat1Desc: 'Calculada para tu carta natal',
      previewFeat2Label: 'Carta Natal',
      previewFeat2Desc: 'Sol, Luna, Ascendente y 8 planetas más',
      previewFeat3Label: 'Pregunta a los Astros',
      previewFeat3Desc: '1 pregunta gratis en cuenta nueva',
      viewDashboard: 'Ver mi panel',
      upgradeTitle: 'Profundiza tu viaje',
      upgradeDesc: 'Con Premium desbloqueas la carta natal completa, sinastría, predicciones personalizadas y mucho más, por menos de $1 al día.',
      upgradeF1: 'Carta natal completa',
      upgradeF2: 'Sinastría de relaciones',
      upgradeF3: 'Predicciones diarias personalizadas',
      upgradeF4: 'Preguntas ilimitadas a los astros',
      upgradeF5: 'AstroMatch por foto',
      upgradeCta: 'Suscribirse a Premium ✦',
      upgradeFreeCta: 'Continuar con cuenta gratuita →',
    },
    birthChart: {
      title: 'Carta Natal',
      houseSystem: 'Cálculo Preciso',
      howToRead: 'Cómo leer mi carta',
      calculating: 'Calculando tus planetas y casas astrológicas...',
      planetPositions: 'Posiciones Planetarias',
      planet: 'Planeta', sign: 'Signo', degree: 'Grado', house: 'Casa',
      showAll: 'Ver todos los planetas ({n} más)',
      showLess: 'Mostrar menos',
      interpretation: 'Interpretación ✦',
      calculateCta: 'Calcular mi carta natal',
      retry: '↺ Intentar de nuevo',
      starsMoving: 'Los astros están en movimiento intenso ahora. Intenta de nuevo en un momento ✦',
      emptyTitle: 'Fecha de nacimiento requerida',
      emptySubtitle: 'Para calcular tu carta natal necesitamos tu fecha de nacimiento. Agrégala en Perfil.',
      emptyCta: 'Ir al Perfil',
      guideTitle: 'Cómo leer tu carta',
      guideCta: 'Entendido ✦',
    },
    synastry: {
      title: 'Compatibilidad Astrológica',
      subtitle: 'Sinastría',
      partnerDataTitle: 'Datos de la pareja',
      partnerNameLabel: 'Nombre',
      partnerNamePlaceholder: 'Nombre de la persona',
      partnerSignLabel: 'Signo solar',
      selectSign: 'Selecciona el signo',
      partnerDateLabel: 'Fecha de nacimiento',
      autoAnalyzeHint: 'El análisis inicia automáticamente al rellenar este campo',
      analyzeCta: 'Analizar compatibilidad (1 crédito)',
      inviteText: '¿Prefieres que la otra persona rellene sus propios datos?',
      generateLink: 'Generar enlace de invitación por WhatsApp',
      linkGenerated: 'Enlace generado:',
      copyBtn: 'Copiar',
      compatibility: 'Compatibilidad',
      noCreditsMsg: 'No tienes créditos de sinastría.',
      buyLink: 'Comprar →',
      calculating: 'Calculando la sinastría entre {partner} y {user}...',
      newAnalysis: 'Nueva sinastría',
      errorMsg: 'Análisis de sinastría temporalmente no disponible. Intenta de nuevo ✦',
      emptyTitle: 'Fecha de nacimiento requerida',
      emptySubtitle: 'Agrega tu fecha de nacimiento para hacer sinastría.',
      emptyCta: 'Ir al Perfil',
      tabScore: 'Score', tabAnalise: 'Análisis', tabAspectos: 'Aspectos',
      tabCasas: 'Casas', tabComposto: 'Compuesto', tabDavison: 'Davison',
      tabTransitos: 'Tránsitos', tabProgressoes: 'Progresiones',
      scoreLove: 'Amor y Química', scoreCommunication: 'Comunicación', scoreValues: 'Valores',
      scoreLongTerm: 'Largo Plazo', scoreGrowth: 'Crecimiento', scoreRoutine: 'Rutina', scoreFamily: 'Familia',
    },
    tarot: {
      title: 'Tarot de Marsella',
      subtitle: 'Tradición clásica de Arcanos Mayores y Menores',
      restart: 'Reiniciar',
      intentionMsg: 'Concéntrate en una pregunta...',
      loading: 'Los arcanos se están organizando...',
      generalReading: '✦ Lectura General',
      reversed: 'Invertida',
      spreadSingle: 'Carta del Día',
      spreadSingleDesc: '1 carta, enfoque y energía del momento',
      spreadThree: 'Pasado · Presente · Futuro',
      spreadThreeDesc: '3 cartas, línea del tiempo',
      spreadHorseshoe: 'Herradura',
      spreadHorseshoeDesc: '7 cartas, visión amplia de la situación',
      spreadCeltic: 'Cruz Celta',
      spreadCelticDesc: '10 cartas, análisis profundo',
    },
    lenormand: {
      title: 'Barajas Gitanas',
      subtitle: 'Lenormand, El oráculo de 36 cartas',
      restart: 'Nueva lectura',
      intentionMsg: 'Respira profundo y concéntrate en tu consulta...',
      loading: 'Las cartas gitanas se están revelando...',
      readingTitle: '✦ Tu Lectura',
      subscriptionRequired: 'Esta consulta está disponible para suscriptores mensuales o anuales.',
      spreadSingle: 'Carta del Momento',
      spreadSingleDesc: '1 carta, el mensaje esencial',
      spreadThree: 'Línea del Tiempo',
      spreadThreeDesc: '3 cartas, pasado, presente y camino',
      spreadFive: 'Cruz',
      spreadFiveDesc: '5 cartas, situación y consejo',
      spreadNine: 'Cuadrado',
      spreadNineDesc: '9 cartas, lectura completa',
      questionLabel: 'Tu consulta (opcional)',
      questionPlaceholder: '¿Qué deseas comprender? Déjalo en blanco para una lectura general.',
      questionCta: 'Revelar las cartas ✦',
    },
    questions: {
      title: 'Pregunta a los Astros',
      questionLabel: 'Tu pregunta',
      questionPlaceholder: 'Escribe tu pregunta para los astros...',
      showExamples: 'Ver ejemplos de preguntas',
      hideExamples: 'Ocultar ejemplos',
      disclaimer: 'Respuestas de carácter reflexivo · Consulta profesionales para decisiones importantes',
      submitCta: 'Preguntar (1 crédito)',
      submitLoading: 'Consultando los astros...',
      answerTitle: '✦ Los astros responden',
      historyTitle: 'Historial de preguntas',
      noCreditsTitle: 'No tienes suficientes créditos. ¿Quieres recargar?',
      noCreditsDesc: 'Tus créditos se agotaron. Elige un paquete abajo para continuar.',
      loading: 'Los astros están considerando tu pregunta...',
      emptyTitle: 'Completa tu perfil primero',
      emptySubtitle: 'Agrega tu fecha de nacimiento para hacer preguntas personalizadas a los astros.',
      emptyCta: 'Ir al Perfil',
    },
    numerology: {
      title: 'Numerología',
      subtitle: 'Los números que rigen tu camino',
      intro: 'Calcula tu mapa numerológico completo basado en tu nombre y fecha de nacimiento.',
      calculateCta: 'Calcular mi numerología ✦',
      calculating: 'Los números están siendo calculados...',
      lifePathLabel: 'Camino de Vida',
      destinyLabel: 'Destino',
      soulLabel: 'Alma',
      personalityLabel: 'Personalidad',
      newConsult: 'Nueva consulta',
      error: 'Los números están en alineación. Intenta de nuevo en un momento ✦',
      emptyTitle: 'Datos requeridos',
      emptySubtitle: 'Agrega tu nombre y fecha de nacimiento en tu perfil para calcular tu numerología.',
      emptyCta: 'Ir al Perfil',
      tabSinteseGeral: 'Síntesis General', tabCaminhoDeVida: 'Camino de Vida',
      tabDestino: 'Número del Destino', tabAlma: 'Número del Alma', tabPersonalidade: 'Personalidad',
    },
    iching: {
      title: 'I Ching',
      subtitle: 'El Libro de los Cambios',
      intro: 'El I Ching consulta los patrones de mutación del universo para revelar la esencia de tu situación.',
      questionLabel: 'Tu pregunta',
      questionPlaceholder: '¿Qué deseas comprender?',
      throwingCoins: 'Lanzando las monedas...',
      consultCta: 'Consultar el oráculo ✦',
      throwingMsg: 'Lanzando las monedas sagradas...',
      interpretingMsg: 'El oráculo está interpretando las mutaciones...',
      hexagramLabel: 'Hexagrama {n}, {name}',
      transformsInto: 'Se transforma en: Hexagrama {n}',
      newConsult: 'Nueva consulta',
      error: 'El oráculo está en silencio. Intenta de nuevo en un momento ✦',
    },
    dreamJournal: {
      title: 'Diario de Sueños',
      subtitle: 'Descubre los mensajes del inconsciente',
      dreamLabel: 'Describe tu sueño',
      dreamPlaceholder: 'Describe con detalle lo que soñaste... Personas, lugares, sensaciones, colores...',
      interpretCta: 'Interpretar mi sueño ✦',
      loading: 'Sumergiéndose en las capas del inconsciente...',
      symbolsTitle: '✦ Símbolos identificados',
      interpretationTitle: '✦ Interpretación',
      guidanceTitle: '✦ Orientación',
      historyTitle: 'Diario',
      newEntry: 'Registrar otro sueño',
      error: 'El inconsciente está en silencio. Intenta de nuevo en un momento ✦',
    },
    moonPhases: {
      title: 'Fases de la Luna',
      subtitle: 'Calendario lunar y energías del ciclo',
      illuminated: '{n}% iluminada',
      upcomingPhases: '✦ Próximas fases',
      ritualsFor: '✦ Rituales para {phase}',
    },
    humanDesign: {
      title: 'Diseño Humano',
      subtitle: 'Tu tipo y estrategia de vida',
      intro: 'Descubre tu tipo de Diseño Humano, estrategia de vida y autoridad interna para tomar decisiones con claridad.',
      calculateCta: 'Calcular mi Diseño Humano ✦',
      calculating: 'Calculando tu Diseño Humano...',
      birthTimeWarning: '✦ Hora de nacimiento recomendada',
      birthTimeWarningDesc: 'El Diseño Humano es más preciso con tu hora de nacimiento. Sin ella, usaremos un cálculo aproximado.',
      addBirthTime: 'Agregar hora de nacimiento →',
      profileLabel: 'Perfil',
      authorityLabel: 'Autoridad',
      strategyLabel: 'Estrategia',
      signatureLabel: 'Firma',
      notSelfLabel: 'No-Yo',
      centersTitle: '✦ Centros',
      recalculate: 'Recalcular',
      error: 'El sistema de Diseño Humano está en análisis. Intenta de nuevo en un momento ✦',
      emptyTitle: 'Fecha de nacimiento requerida',
      emptySubtitle: 'Agrega tu fecha de nacimiento para calcular tu Diseño Humano.',
      emptyCta: 'Ir al Perfil',
    },
    vedicAstrology: {
      title: 'Astrología Védica',
      subtitle: 'Jyotish, la Ciencia de la Luz',
      intro: 'La astrología védica (Jyotish) es un sistema milenario de la India que usa el zodíaco sidéreo, revelando capas profundas del destino, karma y propósito.',
      consultCta: 'Consultar Jyotish ✦',
      loading: 'Calculando el mapa védico...',
      addBirthTime: '✦ Agregar tu hora de nacimiento hace la lectura mucho más precisa.',
      keyPositions: '✦ Posiciones clave',
      ascLabel: 'Ascendente (Lagna)',
      moonLabel: 'Signo de la Luna',
      sunLabel: 'Signo del Sol',
      nakshatraLabel: 'Nakshatra',
      dashaLabel: 'Dasha actual',
      yogasLabel: 'Yogas presentes',
      newConsult: 'Nueva consulta',
      error: 'Los astros védicos están en alineación. Intenta de nuevo en un momento ✦',
      emptyTitle: 'Fecha de nacimiento requerida',
      emptySubtitle: 'Agrega tu fecha de nacimiento para acceder a la astrología védica.',
      emptyCta: 'Ir al Perfil',
    },
    astromatch: {
      title: 'AstroMatch',
      subtitle: 'Análisis astrológico por fisiognomía',
      subjectNameLabel: 'Nombre de la persona',
      subjectNameOptional: '(opcional)',
      subjectNamePlaceholder: 'Ej: Juan',
      cameraBtn: 'Cámara / Galería',
      noConsent: '↑ Acepta los términos de arriba para habilitar el envío de foto',
      newAnalysis: 'Nuevo análisis',
      errorMsg: 'No fue posible procesar el análisis. Inténtalo de nuevo ✦',
      errorRetry: 'Intentar con otra foto',
      loading1: 'Analizando rasgos faciales...',
      loading2: 'Consultando los astros...',
      loading3: 'Calculando la carta natal...',
      loading4: 'Preparando tu análisis ✦',
    },
    quiromancy: {
      title: 'Quiromancia',
      subtitle: 'Lectura de las líneas de la mano',
      handSelectorLabel: '¿Qué mano deseas analizar?',
      rightHand: 'Mano Derecha',
      leftHand: 'Mano Izquierda',
      rightHandHint: 'Mano derecha, destino y presente',
      leftHandHint: 'Mano izquierda, potencial innato',
      instructions: 'Fotografía la palma abierta con buena iluminación y fondo claro.',
      handTypeLabel: '✦ Tipo de mano',
      cameraBtn: 'Cámara / Galería',
      noConsent: '↑ Acepta los términos de arriba para habilitar el envío de foto',
      newAnalysis: 'Nuevo análisis',
      errorMsg: 'No pudimos leer las líneas de esta imagen. Asegúrate de que la palma esté bien visible e iluminada.',
      errorRetry: 'Intentar con otra foto',
      loading1: 'Analizando las líneas de la mano...',
      loading2: 'Identificando los montes...',
      loading3: 'Consultando los astros...',
      loading4: 'Preparando tu lectura ✦',
    },
    startAstral: {
      tabTalentos: 'Talentos', tabDesafios: 'Desafíos', tabAmbientes: 'Ambientes',
      tabLideranca: 'Liderazgo', tabAreas: 'Áreas Profesionales', tabCaminhos: 'Caminos Desafiantes', tabCiclos: 'Ciclos',
      tabVocacional: 'Mapa Vocacional', tabAtual: 'Carrera Actual', tabAlmejada: 'Puesto Deseado', tabTransicao: 'Transición',
    },
    readings: {
      title: 'Lecturas',
      subtitle: 'Tu historial de consultas',
      emptyAll: 'No se encontraron lecturas todavía.',
      emptyFilter: 'No hay lecturas de este tipo todavía.',
      reading: 'Lectura',
    },
    notFound: {
      title: 'Página no encontrada',
      body:  'Los astros no pudieron localizar esta página. Quizás se perdió en el cosmos.',
      back:  'Volver al inicio',
    },
    servicos: {
      heroCtaStart:          'Comenzar ahora',
      heroCtaAccess:         'Acceder',
      heroBadgeFree:         'Disponible en todos los planes',
      heroBadgeMonthly:      'Disponible desde el Plan Mensual',
      heroBadgeAnnual:       'Exclusivo del Plan Anual',
      tierFree:              'Gratuito',
      tierMonthly:           'Mensual',
      tierAnnual:            'Anual',
      benefitsTitle:         'Lo que vas a descubrir',
      forWhoTitle:           'Este servicio es para ti si...',
      previewTitle:          'Un anticipo de lo que vas a recibir',
      previewSubtitle:       'Ejemplo ilustrativo, tu análisis es siempre único',
      previewUnlock:         '✦ Desbloquea tu análisis completo',
      plansTitle:            'Elige tu plan y comienza ahora',
      plansRecommended:      '✦ RECOMENDADO PARA ESTE SERVICIO',
      testimonialsTitle:     'Lo que dicen nuestras usuarias',
      faqTitle:              'Preguntas frecuentes',
      finalCtaTitle:         'Empieza ahora y recibe tu análisis en instantes',
      finalCtaAnonDesc:      'Toma menos de un minuto crear tu cuenta y explorar el universo Professya.',
      finalCtaCreateAccount: 'Crear cuenta gratuita',
      finalCtaHaveAccount:   'Ya tengo cuenta',
      comingSoonBtn:         'Próximamente ✦',
      comingSoonBadge:       'Lanzamiento próximo',
      comingSoonDesc:        'Estamos dando los últimos toques. Pronto podrás acceder a este servicio en Professya.',
    },
    profile: {
      title:    'Mi Cuenta',
      subtitle: 'Gestiona tu información y seguridad.',
      planSection:  'Mi Plan',
      currentPlan:  'Plan actual:',
      planFree:     'Gratuito',
      planMonthly:  'Mensual',
      planAnnual:   'Anual',
      planFreeFull:    'Gratuito',
      planMonthlyFull: 'Professya Mensual',
      planAnnualFull:  'Professya Anual',
      cancelCta:    'Cancelar suscripción',
      cancelPrompt: 'Te echaremos de menos. Si quieres contarnos el motivo (opcional):',
      cancelReasonPricey:        'Se volvió caro',
      cancelReasonUnused:        'No lo uso tanto como esperaba',
      cancelReasonPause:         'Voy a pausar y volver',
      cancelReasonOtherPlatform: 'Encontré otra plataforma',
      cancelReasonMisc:          'Otro motivo',
      cancelConfirmCta: 'Cancelar mi suscripción',
      cancelling:       'Cancelando...',
      cancelError:      'No fue posible cancelar. Inténtalo de nuevo o contáctanos.',
      cancelBack:       'Volver',
      accountSection:   'Información de la cuenta',
      nameLabel:        'Nombre:',
      emailLabel:       'Email:',
      planLabel:        'Plan:',
      birthSection:     'Datos de nacimiento',
      birthEditBtn:     'Editar',
      birthDateLabel:   'Fecha:',
      birthTimeLabel:   'Hora:',
      birthCityLabel:   'Ciudad:',
      birthTimeNotSet:  'No informada',
      birthSaveSuccess: 'Datos actualizados. Recalculando tu mapa natal...',
      birthDateFormLabel: 'Fecha de nacimiento',
      birthTimeFormLabel: 'Hora de nacimiento (opcional)',
      birthCityFormLabel: 'Ciudad de nacimiento',
      birthCityPlaceholder: 'Ej: Buenos Aires',
      saveCta:      'Guardar',
      savingCta:    'Guardando...',
      cancelEditCta: 'Cancelar',
      confirmTitle: '¿Recalcular mapa natal?',
      confirmDesc:  'Cambiar tu fecha de nacimiento recalculará tu mapa natal. Tus lecturas anteriores no se verán afectadas, pero las nuevas usarán los datos actualizados.',
      confirmCta:   'Confirmar y recalcular',
      securitySection: 'Seguridad',
      genderLabel: 'Género:', genderM: 'Masculino', genderF: 'Femenino', genderNB: 'No binario', genderNotSay: 'Prefiero no decirlo',
      birthLimitError: 'Has alcanzado el límite de 2 cambios de datos de nacimiento. Contacta con el soporte para solicitar una corrección.',
    },
  },
  shared: {
    privacyTitle: 'Tu privacidad es prioridad',
    privacyDesc: 'La foto se procesa solo para análisis y nunca se guarda en nuestros servidores. Los datos de geolocalización (EXIF) se eliminan antes del envío.',
    privacyConsent: '✓ Entendido, la foto no se guardará. Acepto continuar.',
    feedbackQuestion: '¿Esta lectura fue útil?',
    feedbackThanks: '¡Gracias por tu opinión!',
    shareWhatsApp: 'Compartir mi Secreto Astral ✦',
    shareCopied: '¡Texto copiado! Pégalo en WhatsApp ✦',
    shareError: 'No se pudo compartir. Intenta copiar el texto manualmente.',
    buyCredits: 'Comprar créditos ✦',
    newConsult: 'Nueva consulta',
    retry: 'Intentar de nuevo',
  },
};

export default es;
